import { FC } from "react"

import { TournamentAnalytics } from "types/tournament.types"

import { formatTournamentMoney, usdCentsToCurrencyMinor } from "util/formatter"

interface TournamentAnalyticsCardsProps {
  analytics: TournamentAnalytics
  currency?: string
  currencyRate?: number
}

export const TournamentAnalyticsCards: FC<TournamentAnalyticsCardsProps> = ({ analytics, currency, currencyRate }) => {
  const cards: { label: string; value: string | number }[] = [
    { label: "Total Participants", value: analytics.total_participants },
    { label: "Total Spins", value: analytics.total_spins.toLocaleString() },
    { label: "Total Wagered", value: formatTournamentMoney(usdCentsToCurrencyMinor(analytics.total_wagered, currencyRate), currency) },
    { label: "Avg Score/Player", value: Number(analytics.avg_score_per_player || 0).toFixed(0) }
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
      {cards.map((card) => (
        <div
          key={card.label}
          className="p-6 bg-white dark:bg-[#0C0C1A] rounded-xl border border-[rgba(0,0,0,0.05)] dark:border-[rgba(255,255,255,0.1)] shadow-sm"
        >
          <div className="text-sm text-gray-500 dark:text-gray-400">{card.label}</div>
          <div className="text-3xl font-bold text-gray-900 dark:text-white mt-2">{card.value}</div>
        </div>
      ))}
    </div>
  )
}
